import { render, staticRenderFns } from "./ECommerceProductCard.vue?vue&type=template&id=324ad6a4"
import script from "./ECommerceProductCard.vue?vue&type=script&lang=js"
export * from "./ECommerceProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports